import WG from '../../../common/modules/wg';
import merge from 'lodash.merge';

const global = window.wrike;
const ContactSales = window.ContactSales;
const modalId = 'modal-contact-us-screenshots';
const $modal = $(`#${modalId}`);

if ($modal.length) {
    const contactSales = new ContactSales({
        subType: 'WebsiteHomeVgPage',
        clientId: 'enterpriseRequest',
        $handler: $(`[data-show="${modalId}"]`),
        $form: $modal.find('form'),
        $successMessage: $modal.find('.modal-form-contact__success'),
        $closeHandler: $modal.find('.modal-form-contact__close'),
        classCloseColorInvert: 'modal-form-contact__close--white',
        marketoId: 2005,
        marketoFormType: 'contact_sales',
        onOpen: function(sales) {
            const source = sales.source;

            global.trackEventForm({
                event: source,
                value: {
                    subtype: 'pop_up',
                    content: source
                }
            });
        },
        onSuccess: function(sales) {
            const { formData } = sales;
            const defaultData = {
                value: {
                    form: 'pop_up',
                    subtype: formData['tracking-subtype'],
                    content: formData['tracking-content'],
                    type: 'contact',
                    email: formData.email,
                    name: formData.name,
                    phone_number: `${formData['code']} ${formData['phone']}`,
                    description: formData.question,
                    job_title: formData.job_role,
                    job_role: formData.job_level
                }
            };

            const statSiteData = {
                event: 'contact_sales_form__submit'
            };

            const airPrData = {
                event: 'non_trial_form__submitted',
                value: {
                    event: 'contact_sales_form__submitted'
                }
            };

            global.trackEventForm(merge(defaultData, statSiteData), false);
            new WG.AirPrTracking(merge(defaultData, airPrData));
        }
    });

    contactSales.init();
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/modal-form.js